module.exports = __webpack_public_path__ + "static/media/left-hand.19941b7b.png";